const nectarYellow = {
  main: "#e1c80b",
  light: "#ebd534",
  dark: "#cfb600",
};

export { nectarYellow };
